import { createClient } from "@sanity/client";

export default createClient({
  projectId: 'hi7eel47',
  dataset: 'production',
  apiVersion: '2022-03-25',
  useCdn: false,
});
